import { Cliente } from './cliente';
import { Bodega } from './bodega';
import { PlanAcumulativoDetalle } from './plan-acumulativo-detalle';
import { Cobro } from './cobro';
import { CobroGrupo } from './cobro-grupo';

export class PlanAcumulativo{    
    public constructor(
        public id: String = "",
        public secuencial: String = "",
        public subtotal: number = 0,
        public subtotal_iva0: number = 0,
        public subtotal_iva12: number = 0,
        public desc_valor: number = 0,
        public subt_desct_iva0: number = 0,
        public subt_desct_iva12: number = 0,
        public iva: number = 0,
        public total: number = 0,
        public abonado: number = 0,
        public estado_pago: String = "",
        public observacion: String = "",
        public tipo_comprobante_id: String = "",
        public cliente_id: String = "",
        public bodega_id: String = "1",
        public venta_id: String = "",
        public fecha_caducidad: any = "",

        public empresa_id: String = "",
        public sucursal_id: String = "",
        public usuario_id:String = null,
        public status: String = "",
        

        public cliente: Cliente = new Cliente(),
        public bodega: Bodega = new Bodega(),
        public tipocomprobante: any = {},
        public detalle: Array<PlanAcumulativoDetalle> = [],
        public cobros: Array<Cobro> = [],
        public grupo: Array<CobroGrupo> = [],
    ){}
}


// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/models/plan-acumulativo.ts